import type { Mailbox } from "./api-client";

// Stalwart nombra los mailboxes de rol estándar en inglés ("Deleted Items",
// "Sent Items", etc.) — esos nombres nunca se tocan del lado del servidor
// (otros clientes IMAP como SnappyMail dependen de ellos), esto es solo la
// etiqueta que se muestra en esta app. Carpetas de usuario (role: null,
// ej. "Notion") se muestran con su nombre real tal cual.
const ROLE_LABELS: Record<string, string> = {
  inbox: "Recibidos",
  drafts: "Borradores",
  sent: "Enviados",
  junk: "Spam",
  trash: "Papelera",
  archive: "Archivados",
};

export function mailboxLabel(mailbox: Pick<Mailbox, "name" | "role">): string {
  return (mailbox.role && ROLE_LABELS[mailbox.role]) || mailbox.name;
}
